import React from 'react';
import { Radio, Input, InputNumber, Row, Col, message,Checkbox, Icon, Tooltip } from 'antd'
import { InputType, WidthType, RegularExpression } from './input-const'; 
import NHSelect from '../NHSelect/index'

const RadioGroup = Radio.Group;

//最小宽度
const minWidth = 1;


/*
 * @Description:
 * @Author: zengweijin
 * @LastEditors: zengweijin
 * @Date: 2019-04-22 13:52:24
 * @LastEditTime: 2019-04-22 13:53:48
 */

class SettingNHCascader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feature: '', //原参数json字符串
            width: minWidth, //设置的宽度值，初始为最小宽度值
            featureParams: {
                name: '级联下拉选择器组件',
                type: InputType.NHCASCADER, //控件类型，必须有此属性，用于渲染时期判断控件类型
                widthType: WidthType.DEFAULT, //宽度类型：自适应'default'、百分比'relative'、固定值'fixed'
                widthStr: '', //input宽度值
                dataTag: '', //下拉数据标识
                required: false, //是否必须
                defaultValue: [], //默认值
                validationValueType: 'array', //用于校验的值的类型
                baseUrl:null,                 // 服务api前缀
                changeOnSelect:false,         // 是否点击每级选项都会发生变化
            },
            showSelect:false,
        }
    }

    static defaultProps = {
        initFeature: ''
    }

    //在渲染前调用,可在此最后一次初始化组件状态
    componentWillMount() {
        //将输入控件配置参数设置到状态中
        if (this.props.initFeature) {
            try {
                let initFeature = JSON.parse(this.props.initFeature);
                if (initFeature.type == InputType.NHCASCADER) {
                    let { widthType, widthStr = '', dataTag = '', required = false, defaultValue = [] , baseUrl } = initFeature;
                    let width = '';

                    if (widthType == WidthType.RELATIVE) {
                        width = widthStr.replace('%', '');
                    } else if (widthType == WidthType.FIXED) {
                        width = widthStr.replace('px', '');
                    }

                    const fp = { ...this.state.featureParams };
                    fp.widthType = widthType;
                    fp.widthStr = widthStr;
                    fp.dataTag = dataTag;
                    fp.required = required;
                    fp.defaultValue = defaultValue;
                    fp.baseUrl = baseUrl;

                    this.setState({
                        feature: this.props.initFeature,
                        width: width,
                        featureParams: fp
                    });
                }

            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        } else {
            try {
                let feature = JSON.stringify(this.state.featureParams);
                this.setState({
                    feature: feature
                });
            } catch (e) {
                console.log(e);
                message.error('生成控件配置参数出错！');
            }
        }
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    //切换宽度类型radio时回调，清空之前的值
    handleWidthRadioChange = (e) => {
        let widthType = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.widthType = widthType;
        fp.widthStr = '';

        this.setState({ width: '', featureParams: fp });
        this.createFeature(fp);
    }

    //宽度值改变的时候，同步更新状态参数
    handleWidthChange = (value) => {
        let widthStr;
        let widthType = this.state.featureParams.widthType;

        if (widthType == WidthType.RELATIVE) {
            widthStr = value + '%';
        } else if (widthType == WidthType.FIXED) {
            widthStr = value + 'px';
        } else {
            widthStr = '';
        }

        const fp = { ...this.state.featureParams };
        fp.widthStr = widthStr;

        this.setState({ width: value, featureParams: fp });
        this.createFeature(fp);
    }

    //当下拉数据标识改变时
    handleDataTagChange = (e) => {
        let dataTag = e.target.value;
        const fp = { ...this.state.featureParams };
        if (dataTag.length > 0) {
            //只能输入英文
            let en_characters_pattern = new RegExp(RegularExpression.EN_NUMBER_UNDERLINE.pattern);
            if (!en_characters_pattern.test(dataTag)) {
                dataTag = '';
            } else {
                //dataTag = dataTag.toLowerCase(); //将英文字母统一转换为小写
            }
        }
        fp.dataTag = dataTag;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当是否必填改变时
    handleRequiredRadioChange = (e) => {
        let required = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.required = required;

        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //当输入默认值改变时
    handleDefaultValueChange = (e) => {
        let defaultValue = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.defaultValue = defaultValue.split(',');
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //生成feature参数json字符串
    createFeature = (featureParams) => {

        try {
            let feature = JSON.stringify(featureParams);
            this.setState({
                feature: feature
            });
            this.props.onChange(feature);
        } catch (e) {
            console.log(e);
            message.error('生成控件配置参数出错！');
        }
    }
    radioChange = (e)=>{
      let value = e.target.checked;
      this.setState({showSelect:value})

    }
    selectChange = (v)=>{
      const fp = { ...this.state.featureParams };
      fp.baseUrl = v;
      this.setState({ featureParams: fp });
      this.createFeature(fp);
    }

    // handleChangeOnSelectRadioChange = (e)=>{
    //   let changeOnSelect = e.target.value;

    //     const fp = { ...this.state.featureParams };
    //     fp.changeOnSelect = changeOnSelect;

    //     this.setState({ featureParams: fp });
    //     this.createFeature(fp);
    // }
    render() {

        let width = this.state.width;
        let { widthType, dataTag, required, defaultValue, changeOnSelect , baseUrl } = this.state.featureParams;
        let showSelectFlag = this.state.showSelect === true || (baseUrl!==undefined && baseUrl!==null && baseUrl!=="");
        return (
            <div id="input-setting-div">
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>宽度</div></Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleWidthRadioChange} name="widthradiogroup"
                            value={widthType}>
                            <Radio value={WidthType.DEFAULT}>
                                自适应
                            </Radio>
                            <Radio value={WidthType.RELATIVE}>
                                百分比
                            </Radio>
                            <Radio value={WidthType.FIXED}>
                                固定宽度
                            </Radio>
                        </RadioGroup>
                    </Col>
                    <Col>
                        {
                            widthType == WidthType.RELATIVE ?
                                <InputNumber size="small"
                                    min={minWidth}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                    onChange={this.handleWidthChange}
                                    value={width} />
                                : (
                                    widthType == WidthType.FIXED ?
                                        <InputNumber size="small"
                                            min={minWidth}
                                            formatter={value => `${value}px`}
                                            parser={value => value.replace('px', '')}
                                            onChange={this.handleWidthChange}
                                            value={width} />
                                        : null
                                )
                        }
                    </Col>
                </Row>
                <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>下拉数据标识</div></Col>
                </Row>
                <Row gutter={8}>
                    <Col span={6} >
                        <Checkbox onChange={this.radioChange} checked={showSelectFlag}>指定服务</Checkbox>
                        <Tooltip  title={'不指定服务的情况下默认使用当前服务'} placement='top' ><Icon  type="question-circle" /></Tooltip>
                    </Col>
                    <Col span={18}>{showSelectFlag && <NHSelect style={{marginLeft:6,width:'200px'}} onChange={this.selectChange} value={baseUrl} baseUrl={'api/zhxg-xtgl'} sign={'zhxg_server_select'}/>}</Col>
                </Row>
                <Row type='flex' style={{marginTop:10}}>
                  <Col span={12}>
                      <div style={{display:"flex"}}>
                        <span style={{color:"red",fontSize:"14px",padding:"5px"}}>*</span>
                        <Input placeholder="请输入下拉数据英文字母标识 " value={dataTag} onChange={this.handleDataTagChange} style={{width:"110%"}}/>
                      </div>
                    </Col>
                </Row>
              {/*   <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>是否必填</div></Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleRequiredRadioChange} name="requiredradiogroup"
                            value={required}>
                            <Radio value={false}>
                                非必填
                            </Radio>
                            <Radio value={true}>
                                必填
                            </Radio>
                        </RadioGroup>
                    </Col>
                </Row> */}
                {/* <Row type="flex">
                    <Col><div style={{ margin: "16px 0" }}>是否点击每级菜单选项值都会发生变化</div></Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleChangeOnSelectRadioChange} name="changeOnSelectradiogroup"
                            value={changeOnSelect}>
                            <Radio value={false}>
                                否
                            </Radio>
                            <Radio value={true}>
                                是
                            </Radio>
                        </RadioGroup>
                    </Col>
                </Row> */}
                <Row type="flex">
                    <Col span={24}><div style={{ margin: "16px 0" }}>默认值</div></Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <Input.TextArea rows={4} placeholder="请输入默认值,多个使用“，”分隔" onChange={this.handleDefaultValueChange} value={defaultValue.join(',')} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default SettingNHCascader;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-nhcascader.js